<template>
  <v-dialog v-model="modelValue" max-width="600px">
    <v-card>
      <v-card-title>Contract Details</v-card-title>
      <v-card-text>
        <pre>{{ contract }}</pre>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="$emit('update:modelValue', false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ArchiveContractDialog',
  props: {
    modelValue: Boolean,
    contract: Object
  },
  emits: ['update:modelValue']
}
</script>
